(() => {
  const init = (root) => {
    if (!root || root.dataset.cwPdpReady === 'true') return;
    root.dataset.cwPdpReady = 'true';
    const parse = (selector, fallback) => {
      try { return JSON.parse(root.querySelector(selector)?.textContent || 'null') || fallback; }
      catch { return fallback; }
    };
    const variants = parse('[data-cw-variants]', []);
    const strings = { add: 'Add to basket', unavailable: 'Unavailable', combination_unavailable: 'Combination unavailable', available: 'Available to order', currently_unavailable: 'Currently unavailable', save: 'Save', ...parse('[data-cw-strings]', {}) };
    const currency = document.documentElement.dataset.currency || window.Shopify?.currency?.active || 'GBP';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency });
    const money = cents => formatter.format(Number(cents || 0) / 100);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const galleryStage = root.querySelector('[data-cw-gallery-stage]');
    const galleryCount = root.querySelector('[data-cw-gallery-count]');
    const mediaItems = [...root.querySelectorAll('[data-cw-media]')];
    const thumbs = [...root.querySelectorAll('[data-cw-thumb]')];
    const zoom = root.querySelector('[data-cw-zoom]');
    let activeMediaIndex = Math.max(0, mediaItems.findIndex(item => item.classList.contains('is-active')));
    const syncGallery = () => {
      if (galleryCount) galleryCount.textContent = `${activeMediaIndex + 1} / ${mediaItems.length}`;
      if (zoom) zoom.hidden = !mediaItems[activeMediaIndex]?.dataset.cwZoomSrc;
    };
    const showMedia = (id, revealThumb = true) => {
      const index = mediaItems.findIndex(item => String(item.dataset.cwMedia) === String(id));
      if (index < 0) return;
      activeMediaIndex = index;
      mediaItems.forEach((item, position) => {
        const active = position === index;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        if (!active) item.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(button => {
        const active = String(button.dataset.cwThumb) === String(id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (active && revealThumb) {
          const strip = button.parentElement;
          strip?.scrollTo({ left: button.offsetLeft - strip.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      });
      syncGallery();
    };
    const stepMedia = direction => {
      if (mediaItems.length > 1) showMedia(mediaItems[(activeMediaIndex + direction + mediaItems.length) % mediaItems.length].dataset.cwMedia);
    };
    thumbs.forEach(button => button.addEventListener('click', () => showMedia(button.dataset.cwThumb)));
    root.querySelector('[data-cw-gallery-prev]')?.addEventListener('click', () => stepMedia(-1));
    root.querySelector('[data-cw-gallery-next]')?.addEventListener('click', () => stepMedia(1));
    galleryStage?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        stepMedia(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    let touchStart = null;
    galleryStage?.addEventListener('touchstart', event => {
      touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY, time: Date.now() } : null;
    }, { passive: true });
    galleryStage?.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    galleryStage?.addEventListener('touchend', event => {
      const point = event.changedTouches?.[0];
      if (!point || !touchStart) return;
      const deltaX = point.clientX - touchStart.x, deltaY = point.clientY - touchStart.y;
      if (Date.now() - touchStart.time < 900 && Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) stepMedia(deltaX < 0 ? 1 : -1);
      touchStart = null;
    }, { passive: true });
    const lightbox = root.querySelector('[data-cw-lightbox]');
    const lightboxImage = root.querySelector('[data-cw-lightbox-image]');
    const lightboxCount = root.querySelector('[data-cw-lightbox-count]');
    const imageItems = mediaItems.filter(item => item.dataset.cwZoomSrc);
    const lightboxPrev = root.querySelector('[data-cw-lightbox-prev]');
    const lightboxNext = root.querySelector('[data-cw-lightbox-next]');
    [lightboxPrev, lightboxNext].forEach(button => { if (button) button.hidden = imageItems.length < 2; });
    const updateLightbox = () => {
      const item = mediaItems[activeMediaIndex];
      const image = item?.querySelector('img');
      if (!item?.dataset.cwZoomSrc || !lightboxImage) return false;
      lightboxImage.src = item.dataset.cwZoomSrc;
      lightboxImage.alt = image?.alt || root.dataset.productTitle || '';
      if (lightboxCount) lightboxCount.textContent = `${imageItems.indexOf(item) + 1} / ${imageItems.length}`;
      return true;
    };
    const stepLightbox = direction => {
      if (imageItems.length < 2) return;
      const index = imageItems.indexOf(mediaItems[activeMediaIndex]);
      const next = imageItems[(index + direction + imageItems.length) % imageItems.length];
      showMedia(next.dataset.cwMedia, false);
      updateLightbox();
    };
    zoom?.addEventListener('click', () => {
      if (updateLightbox() && typeof lightbox?.showModal === 'function') lightbox.showModal();
    });
    lightboxPrev?.addEventListener('click', () => stepLightbox(-1));
    lightboxNext?.addEventListener('click', () => stepLightbox(1));
    root.querySelector('[data-cw-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        stepLightbox(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
    syncGallery();

    const optionControls = [...root.querySelectorAll('[data-cw-option]')];
    const selectedOptions = () => optionControls.map(field => field.querySelector('[data-cw-option-input]:checked')?.value ?? field.querySelector('[data-cw-option-select]')?.value);
    const variantId = root.querySelector('[data-cw-variant-id]');
    const price = root.querySelector('[data-cw-price]');
    const mobilePrice = root.querySelector('[data-cw-mobile-price]');
    const compare = root.querySelector('[data-cw-compare]');
    const saving = root.querySelector('[data-cw-saving]');
    const badge = root.querySelector('[data-cw-sale-badge]');
    const status = root.querySelector('[data-cw-status]');
    const sku = root.querySelector('[data-cw-sku]');
    const add = root.querySelector('[data-cw-add]');
    const mobileAdd = root.querySelector('[data-cw-mobile-add]');
    const mobileBuy = root.querySelector('[data-cw-mobile-buy]');
    const productForm = root.querySelector('.cw-pdp__form');
    const dynamicCheckout = root.querySelector('.cw-pdp__dynamic');
    const labels = [root.querySelector('[data-cw-add-label]'), root.querySelector('[data-cw-mobile-add-label]')];
    let activeVariant = variants.find(item => String(item.id) === String(variantId?.value)) || variants.find(item => item.available) || variants[0] || null;
    const ensureVariantId = () => { if (variantId) variantId.value = activeVariant ? String(activeVariant.id) : ''; };
    ensureVariantId();
    [0, 500, 1500].forEach(delay => setTimeout(ensureVariantId, delay));
    productForm?.addEventListener('submit', event => {
      ensureVariantId();
      if (!activeVariant?.available) event.preventDefault();
    }, true);
    productForm?.addEventListener('formdata', event => {
      if (activeVariant) event.formData.set('id', String(activeVariant.id));
      else event.formData.delete('id');
    });
    [add, mobileAdd].filter(Boolean).forEach(button => {
      button.addEventListener('pointerdown', ensureVariantId, true);
      button.addEventListener('click', ensureVariantId, true);
    });
    const updateAvailability = variant => {
      const available = Boolean(variant?.available);
      [add, mobileAdd].forEach(button => { if (button) button.disabled = !available; });
      labels.forEach(label => { if (label) label.textContent = available ? strings.add : variant ? strings.unavailable : strings.combination_unavailable; });
      if (mobileAdd) mobileAdd.setAttribute('aria-label', `${available ? strings.add : strings.unavailable}: ${root.dataset.productTitle || ''}`);
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (status) {
        status.classList.toggle('is-unavailable', !available);
        const indicator = document.createElement('i');
        indicator.setAttribute('aria-hidden', 'true');
        status.replaceChildren(indicator, document.createTextNode(available ? strings.available : strings.currently_unavailable));
      }
    };
    const updateVariant = () => {
      if (!variants.length) return;
      if (optionControls.length) {
        const options = selectedOptions();
        activeVariant = variants.find(item => Array.isArray(item.options) && item.options.every((value, index) => String(value) === String(options[index]))) || null;
      }
      ensureVariantId();
      updateAvailability(activeVariant);
      if (!activeVariant) return;
      if (price) price.textContent = money(activeVariant.price);
      if (mobilePrice) mobilePrice.textContent = money(activeVariant.price);
      const cp = Number(activeVariant.compare_at_price || 0), vp = Number(activeVariant.price || 0), saved = Math.max(0, cp - vp);
      if (compare) { compare.textContent = saved > 0 ? money(cp) : ''; compare.classList.toggle('is-hidden', saved <= 0); }
      if (saving) { saving.textContent = saved > 0 ? `${strings.save} ${money(saved)}` : ''; saving.classList.toggle('is-hidden', saved <= 0); }
      if (badge) { badge.textContent = saved > 0 ? `${strings.save} ${money(saved)}` : ''; badge.hidden = saved <= 0; }
      if (sku) sku.textContent = activeVariant.sku || '—';
      const mediaId = activeVariant.featured_media?.id || activeVariant.featured_image?.id;
      if (mediaId) showMedia(mediaId, false);
      if (optionControls.length) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', activeVariant.id);
        window.history.replaceState({}, '', url);
      }
    };
    root.querySelectorAll('[data-cw-option-input], [data-cw-option-select]').forEach(control => control.addEventListener('change', updateVariant));
    updateVariant();
    let stickyFrame = 0;
    const updateMobileBuy = () => {
      stickyFrame = 0;
      const show = Boolean(window.matchMedia('(max-width: 989px)').matches && add && add.getBoundingClientRect().bottom < 0);
      if (mobileBuy) { mobileBuy.classList.toggle('is-visible', show); mobileBuy.setAttribute('aria-hidden', String(!show)); }
      root.classList.toggle('has-mobile-buy', show);
      document.documentElement.classList.toggle('cw-sticky-buy-visible', show);
    };
    const requestMobileBuyUpdate = () => { if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateMobileBuy); };
    window.addEventListener('scroll', requestMobileBuyUpdate, { passive: true });
    window.addEventListener('resize', requestMobileBuyUpdate, { passive: true });
    updateMobileBuy();
  };
  const run = () => document.querySelectorAll('[data-cw-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
